import { BaseAccessRule } from "./BaseAccessRule.js";
class StringAccessClaimRule extends BaseAccessRule {
  constructor(resourceClaims, type) {
    super(resourceClaims, type);
  }
  validate(userClaims) {
    const filteredUserClaims = this.filterClaims(userClaims);
    const resourceClaimStrings = this.resourceClaims.map((claim) => claim.toString());
    return resourceClaimStrings.length === 0 || filteredUserClaims?.some((claim) => resourceClaimStrings.includes(claim.toString()));
  }
  toString() {
    return this.formatResourceClaims(this.getToStringPrefix());
  }
}
class RestrictedStringAccessClaimRule extends BaseAccessRule {
  constructor(resourceClaims, type) {
    super(resourceClaims, type);
  }
  validate(userClaims) {
    const filteredUserClaims = this.filterClaims(userClaims);
    const resourceClaimStrings = this.resourceClaims.map((claim) => claim.toString());
    return resourceClaimStrings.length === 0 || !filteredUserClaims?.some((claim) => resourceClaimStrings.includes(claim.toString()));
  }
  toString() {
    return this.formatResourceClaims(this.getToStringPrefix());
  }
}
export {
  RestrictedStringAccessClaimRule,
  StringAccessClaimRule
};
//# sourceMappingURL=StringAccessClaimRule.js.map
